module.exports = {
    companyName : "北京佳安卫康科技有限公司",
}